import { useElementScrollTop } from '@nsftx/seven-client-retail-vue-common'
import i18n from '@/plugins/translationsPlugin'
import router from '@/router'
import { useNotificationsStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import { HOME_MAIN } from '@/utils/injections/injectionKeys'
import { useLobbyStore } from '@/stores/lobby/lobbyStore'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'
import { resolveLandingRoute } from '@/modules/landing-page/resolveLandingRoute'

export const useOnIdleTimerEnd = () => {
  const { scrollElementToTop } = useElementScrollTop({ injectionKey: HOME_MAIN })

  const onIdleTimerEnd = () => {
    const { t } = i18n.global
    const notificationsStore = useNotificationsStore()
    const lobbyStore = useLobbyStore()
    const cmsConfigStore = useCmsConfigStore()

    // Go back to landing page
    router.push(
      resolveLandingRoute(cmsConfigStore.cmsConfig, {
        lobby: lobbyStore.isLobbyVisible ? 'true' : undefined
      })
    )

    // Scroll to top after inactivity timer ends
    scrollElementToTop()

    notificationsStore.showNotification({
      text: [t('common_landing_page_inactivity')],
      variant: 'info',
      timeout: 3000
    })
  }

  return {
    onIdleTimerEnd
  }
}
